/**
 * Work with the authentication status
 */

export const useAuth = () => {
  const memberState = useState<LoggedInMemberResponseDto | null | undefined>( "member" );
  const { getLoggedInMember, logout: logoutFn } = $isnMemberResource();

  async function refresh () {
    const loggedInMember = await getLoggedInMember();
    console.log( "Member data from API:", loggedInMember );
    memberState.value = loggedInMember;
  }

  async function logout () {
    await logoutFn();

    memberState.value = {
      loggedIn: false,
      member: undefined,
    };
  }

  const isLoggedIn = computed( () => memberState.value?.loggedIn ?? false );

  return {
    isLoggedIn,
    refresh,
    logout };
};
